import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var toggleFacetInFacetsArray = function toggleFacetInFacetsArray(facets, facet) {
  if (facets.includes(facet)) {
    return facets.filter(function (e) {
      return e !== facet;
    });
  }

  return facets.concat(facet);
};

var toggleFacetInFilterBy = function toggleFacetInFilterBy(filterBy, filter, facet) {
  var _filterBy$filter = filterBy[filter],
      filteredBy = _filterBy$filter === void 0 ? [] : _filterBy$filter,
      rest = _objectWithoutProperties(filterBy, [filter].map(_toPropertyKey));

  var skeleton = toggleFacetInFacetsArray(filteredBy, facet);
  return _objectSpread({}, rest, skeleton.length && _defineProperty({}, filter, skeleton));
};

var addUniqFacetInFilterBy = function addUniqFacetInFilterBy(filterBy, filter, facet) {
  var currentFilterBy = filterBy;
  var skeleton = {};

  if (currentFilterBy[filter] && currentFilterBy[filter][0] === facet) {
    skeleton[filter] = [];
  } else {
    skeleton[filter] = [facet];
  }

  return Object.assign(currentFilterBy, skeleton);
};

export { toggleFacetInFacetsArray, toggleFacetInFilterBy, addUniqFacetInFilterBy };